// Crisis Messaging
var crisisMessage = jq('.crisis-messaging');
if (crisisMessage.length) {
    jq('.crisis-messaging a[href="#"]').click(function(e){
        e.preventDefault();
        crisisMessage.addClass('hide');
    });
    var crisisMessageTimestamp = crisisMessage.data('timestamp');
    var crisisMessageCookieName = 'eqMajorAnnouncement';
    var crisisMessageCookie = Cookies.get(crisisMessageCookieName);
    if (crisisMessageCookie != crisisMessageTimestamp) {
        crisisMessage.removeClass('hide');
        Cookies.set(crisisMessageCookieName, crisisMessageTimestamp, {secure: true, domain: window.location.hostname, expires: 7 });
    }
}
jq(function () {
    var fleetSlider = jq('.fleet-slider');
    if (fleetSlider.length) {
        fleetSlider.slick({
            dots: false,
            //appendDots: '.fleet-slider__nav',
            appendArrows: '.fleet-slider__nav',
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: false,
            responsive: [
                {
                  breakpoint: 991,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll:1
                  }
                }
              ]
        });
        // Fleet slider navigation
        fleetSlider.on('afterChange', function (event, slick, currentSlide) {
            var slideTitle = jq(slick.$slides[currentSlide]).find('h2').text();
            fleetSlider.parent().find('.slick-dots li').each(function (i, el) {
                var tabTitle = jq(this).text().trim();
                if (tabTitle == slideTitle) {
                    jq('.slick-dots li').removeClass('slick-active');
                    jq(this).addClass('slick-active');
                    jq(this).next('li').addClass('slick-active');
                }
            });
        });
        fleetSlider.parent().find('.slick-dots li').click(function (e) {
            var goToIndex = Array.from(e.target.parentNode.children).indexOf(e.target);
            fleetSlider.slick('slickGoTo',  goToIndex - 1);
        });
    }
    
    var homeHero = jq('.home-hero .home-hero__images');
    if (homeHero.length) {
        homeHero.slick({
            dots: true,
            arrows: false,
            appendDots: '.home-hero__nav',
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            autoplay: true,
            autoplaySpeed: 3000
        });
    }
});

// Open image request modal on Image Gallery pages
var $requestModal = jq('#requestModal');
$requestModal.on('show.bs.modal', function (e) {
    console.log(e);
    // Populate the thumbnail in the modal
    var modalAnchor = e.relatedTarget;
    document.getElementById('previewImage').setAttribute('src', modalAnchor.getAttribute('data-img-src'));
    // Add gallery and image ID to form
    document.getElementById('galleryId').setAttribute('value', modalAnchor.getAttribute('data-gallery-id'));
    document.getElementById('imageId').setAttribute('value', modalAnchor.getAttribute('data-image-id'));
});
// Use default ruleset instead of recaptcha ruleset
$requestModal.find('form').validate();
$requestModal.find('form').on('submit', function (e) {
    e.preventDefault();
    // Form is valid, submit to the AJAX request page.
    var form = e.target;
    if (jq(form).valid()) {
        var data = {
            email: form.elements.email.value,
            galleryId: form.elements.galleryId.value,
            imageId: form.elements.imageId.value,
            intended_use: form.elements.intended_use.value
            
        };
        jq.post('/request-image', data, function (results) {
            $requestModal.modal('hide');
            jq('body').append('<div class="alert ' + results.alertClass + ' alert-overlay">' + results.message + "</div>");
            setTimeout(function () {
                jq('.alert-overlay').fadeOut(function () {
                    jq(this).remove();
                });
            }, 1000);
        });
    }
});

// Refresh matchheight on tab click
jq('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
    jq.fn.matchHeight._update();    
});

// Fleet slider active checks
// jq('.fleet-slider__nav .slick-dots li').last().click(function(){
//     console.log("last");
//     jq('.fleet-slider__nav .slick-dots li').first().addClass('slick-active');
// });